class GetValidationErrorMessageHandler {
    handle(validation, serverErrors, key, index) {
        const item = this._getItem(validation, key, index);
        const serverError = this._getServerError(serverErrors, key, index);

        if (serverError) {
            return serverError;
        }

        if (!item || !item.$error) {
            return '';
        }

        const { $params } = item;

        for (const key in $params) {
            if (!item[key]) {
                return (
                    this.#getError(key, $params) || 'Something is wrong... 🤔'
                );
            }
        }

        return 'Something is wrong... 🤔';
    }

    _getItem(validation, key, index) {
        if (isNaN(index)) {
            return validation[key];
        }

        return validation.$each[index][key];
    }

    _getServerError(serverErrors, key, index) {
        if (!isNaN(index)) {
            // @TODO
            return '';
        }

        if (serverErrors.length) {
            const errorItem = serverErrors.find(error => error.param === key);

            if (errorItem) {
                return errorItem.message;
            }
        }

        return '';
    }

    #getError(key, params = {}) {
        const messagesTable = {
            required: 'Should not be empty!',
            isFormatValid: 'Wrong format!',
            email: 'Email address is not valid!',
            atLeastOneItem: 'Please add at least one item!',
            hasToBePositiveNumber: 'It has to be a number above 0!',
            maxElements: 'You have chosen too many elements!',
            isYearValid: 'Wrong value!',
            percentage: 'Should be between 0 and 100!',
            canNotBeNegative: 'It can not be negative number!',
            notBeforeStartDate: 'Cannot end before start date!',
            amountTooHigh: 'You have entered too high amount!',
            starsTooMany: 'You have entered too many stars!',
            maxValue: 'You have entered too high value!',
            minValue: 'You have entered too less value!',
            hasToBeDifferentThanZero: 'It has to be different than 0!',
            maxLength: `Text length must be less than or equal ${params?.maxLength?.max}.`
        };

        return messagesTable[key];
    }
}

export default GetValidationErrorMessageHandler;
